import FormItemInput from '@/components/form/FormItemInput.vue'
import FormItemCaptcha from '@/components/form/FormItemCaptcha.vue'
const components={
  install(Vue){
    Vue.component('form-item-input',FormItemInput)
    Vue.component('form-item-captcha', FormItemCaptcha)
  }
}

export default components;
